import { type CSSProperties, memo } from 'react';

import { type PublicClip } from '@air/api';
import { type Clip } from '@air/api/types';

import { AssetGalleryCard, type AssetGalleryCardProps } from '~/components/Gallery/AssetGalleryCard/AssetGalleryCard';
import { DndSortableKanbanItem } from '~/components/KanbanView/KanbanColumnsManagers/shared/KanbanColumnItems/KanbanItem/shared/DndSortableKanbanItem';
import { KANBAN_ITEM_CARD_WIDTH } from '~/components/KanbanView/shared/kanbanConstants';
import { type DndSortableKanbanItemData } from '~/types/DndKit';

type KanbanAssetComponentProps<C> = {
  cardHeight: number;
  dndDisabled?: boolean;
  kanbanDndItemData: DndSortableKanbanItemData;
  style: CSSProperties;
} & Omit<AssetGalleryCardProps<C>, 'cardWidth'>;
const _KanbanAssetComponent = <C extends Clip | PublicClip>({
  cardHeight,
  dndDisabled,
  kanbanDndItemData,
  style,
  ...rest
}: KanbanAssetComponentProps<C>) => {
  return (
    <DndSortableKanbanItem
      style={style}
      id={kanbanDndItemData.sortableKanbanItemKey}
      data={kanbanDndItemData}
      dndDisabled={dndDisabled}
    >
      <div className="relative" style={{ height: cardHeight }}>
        <AssetGalleryCard
          cardWidth={KANBAN_ITEM_CARD_WIDTH}
          cardHeight={cardHeight}
          // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the color pairing
          getButtonClassName={() =>
            'ads:bg-base bg-gray-1 cursor-pointer shadow-md shadow-kanban dark:border ads:border-default dark:border-gray-4'
          }
          {...rest}
        />
      </div>
    </DndSortableKanbanItem>
  );
};

// biome-ignore lint/plugin: memo erases generic params; typeof cast restores inference
export const KanbanAssetComponent = memo(_KanbanAssetComponent) as typeof _KanbanAssetComponent;
